<template>
  <div class="md-layout" style="justify-content: center; align-items: center; height: 100vh;">
    <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-80 main-box">
      <div class="md-layout">
        <div :class="[{'md-large-size-66 md-medium-size-66 md-small-size-100 md-xsmall-size-100': getUserType !== UserTypeEnum.Admin}, {'md-size-100': getUserType === UserTypeEnum.Admin}, 'md-layout-item']">
          <div class="login-wrapper">
            <h1>Welcome!</h1>
            <h2><span v-if="getUserType">{{getUserTypeHeader()}}</span> Login</h2>
            <div v-if="getUserType !== UserTypeEnum.Admin && googleClientId">
              <button class="gsi-material-button" @click="loginWithGoogle()" :disabled="httpWait">
                <div class="gsi-material-button-state"></div>
                <div class="gsi-material-button-content-wrapper">
                  <div class="gsi-material-button-icon">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                      <path fill="none" d="M0 0h48v48H0z"></path>
                    </svg>
                  </div>
                  <span class="gsi-material-button-contents">Continue with Google</span>
                  <span style="display: none;">Continue with Google</span>
                </div>
              </button>
            </div>
            <div>
              <h2 style="margin-bottom: 0px;">OR</h2>
            </div>
          </div>
          <!-- <div v-if="getUserType !== UserTypeEnum.Admin && googleClientId" class="btn-group">
            <md-button :disabled="httpWait" @click="loginWithGoogle()" class="md-raised btn-primary" :class="{ 'btn-disabled' : httpWait }">
              Continue with Google
              <img src="/DeviconGoogle.svg">
            </md-button>
            <h2>OR</h2>
          </div> -->
          <div v-if="getUserType" class="login-form-container">
            <div class="notify-message" v-if="notifyMessage">{{notifyMessage}}</div>
            <div class="md-layout">
              <div class="md-layout-item"></div>
              <md-field class="md-layout-item md-large-size-66 md-medium-size-50 md-small-size-70 md-xsmall-size-80">
                <label style="color: var(--text-primary);">Email</label>
                <md-input v-model="currentEmail" type="email"></md-input>
                <span v-if="inputError === 'email'" class="error form-error">Please enter a valid email</span>
                <span v-if="inputError === 'emailForgotPassword'" class="error form-error">Forgot password requires a valid email</span>
              </md-field>
              <div class="md-layout-item"></div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"></div>
              <md-field class="md-layout-item md-large-size-66 md-medium-size-50 md-small-size-70 md-xsmall-size-80">
                <label style="color: var(--text-primary);">Password</label>
                <md-input type="password" v-model="password"></md-input>
                <span v-if="inputError === 'password'" class="error form-error">Please enter password</span>
              </md-field>
              <div class="md-layout-item"></div>
            </div>
            <div class="forgot-password-container">
              <div class="text-center">
                <span class="blue-link link underline" @click="initiateForgotPassword">Forgot Password?</span>
              </div>
            </div>
            <div class="btn-group">
              <md-button :disabled="httpWait" @click="submitLogin()" class="md-raised btn-primary" :class="{ 'btn-disabled' : httpWait }">
                Login
                <md-progress-spinner v-if="httpWait" class="btn-spin" :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
              </md-button>
            </div>
            <!-- <div v-if="getUserType !== UserTypeEnum.Admin && googleClientId" class="btn-group">
              <md-button :disabled="httpWait" @click="loginWithGoogle()" class="md-raised btn-primary" :class="{ 'btn-disabled' : httpWait }">
                Continue with Google
              </md-button>
            </div> -->
            <span class="error">{{serverError}}</span>
          </div>
        </div>
        <div v-if="getUserType !== UserTypeEnum.Admin" class="md-layout-item md-large-size-33 md-medium-size-33 md-small-size-100 md-xsmall-size-100">
          <div v-if="getUserType" class="register-action-container">
            <div class="register-wrapper">
            </div>
            <div><h3>New User?</h3></div>
            <div class="btn-group register-group">
              <div>
                <button class="gsi-material-button" @click="loginWithGoogle()" :disabled="httpWait">
                  <div class="gsi-material-button-state"></div>
                  <div class="gsi-material-button-content-wrapper">
                    <div class="gsi-material-button-icon">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                        <path fill="none" d="M0 0h48v48H0z"></path>
                      </svg>
                    </div>
                    <span class="gsi-material-button-contents">Sign up with Google</span>
                    <span style="display: none;">Sign up with Google</span>
                  </div>
                </button>
              </div>
              <div>
                <h4>OR</h4>
              </div>
              <div>
                <md-button @click="goToOnboard()" class="md-raised btn-primary">Here</md-button>
              </div>
            </div>
            <span class="error">{{serverError}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { MdButton } from 'vue-material/dist/components'
import { MdField } from 'vue-material/dist/components'
import { MdProgress } from 'vue-material/dist/components'
import { mapGetters, mapActions } from 'vuex'
import { UserTypeEnum } from "temporary-api-types/apiTypes";

Vue.use(MdButton);
Vue.use(MdField);
Vue.use(MdProgress);

const CALLBACK_PATH = '/auth/callback';
const GOOGLE_REDIRECT_URI_STUDENT = process.env.VUE_APP_GOOGLE_REDIRECT_URI_STUDENT;
const GOOGLE_REDIRECT_URI_PROFESSOR = process.env.VUE_APP_GOOGLE_REDIRECT_URI_PROFESSOR;
const GOOGLE_REDIRECT_URI_DEFAULT = process.env.VUE_APP_GOOGLE_REDIRECT_URI;

if(!GOOGLE_REDIRECT_URI_STUDENT || !GOOGLE_REDIRECT_URI_PROFESSOR || !GOOGLE_REDIRECT_URI_DEFAULT) {
  throw new Error('Missing env var');
}

const ensureCallbackPath = (value) => {
  if(!value) {
    return `${window.location.origin}${CALLBACK_PATH}`;
  }

  try {
    const parsed = new URL(value);
    if(parsed.pathname === CALLBACK_PATH) {
      return parsed.toString();
    }
    parsed.pathname = CALLBACK_PATH;
    parsed.search = '';
    parsed.hash = '';
    return parsed.toString();
  } catch(err) {
    return `${window.location.origin}${CALLBACK_PATH}`;
  }
};

const getGoogleRedirectUri = (userType) => {
  if(!GOOGLE_REDIRECT_URI_STUDENT || !GOOGLE_REDIRECT_URI_PROFESSOR || !GOOGLE_REDIRECT_URI_DEFAULT) {
    throw new Error('Missing env var');
  }

  if(userType === UserTypeEnum.Student && GOOGLE_REDIRECT_URI_STUDENT) {
    return ensureCallbackPath(GOOGLE_REDIRECT_URI_STUDENT);
  }

  if((userType === UserTypeEnum.Professor || userType === UserTypeEnum.Admin) && GOOGLE_REDIRECT_URI_PROFESSOR) {
    return ensureCallbackPath(GOOGLE_REDIRECT_URI_PROFESSOR);
  }

  return ensureCallbackPath(GOOGLE_REDIRECT_URI_DEFAULT);
};

export default {
  name: 'Login',
  data() {
    return {
      password: "",
      attrs: {
        currentEmail: ""
      },
      inputError: "",
      serverError: "",
      url: process.env.VUE_APP_LAMBDA_URL,
      googleClientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      UserTypeEnum,
      httpWait: false
    }
  },
  computed: {
    ...mapGetters([
      'getUserType',
      'getTeam',
      'getSemesterList'
    ]),
    currentEmail: {
      get() {
        return this.attrs.currentEmail;
      },
      set(value) {
        this.attrs.currentEmail = value;
      }
    }
  },
  methods: {
    ...mapActions([
      'login',
      'setUserToken',
      'setUserRefreshToken',
      'setUserTokenExpTime',
      'fetchSemesterList',
      'getStudentTeam',
      'setAccessToken',
      'configureUserType',
      'configureUserEmail',
      'validateAdminLicense'
    ]),
    back() {
      this.password = "";
    },
    async initiateForgotPassword() {
      if(this.validateEmail(this.currentEmail)) {
        const data = {
          email: this.currentEmail,
          groupName: this.getUserType
        };
        try {
          const response = await fetch(`${this.url}/forgotPassword`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Request-Method': 'POST'
            },
            body: JSON.stringify(data)
          });
          if(response.ok) {
            // eslint-disable-next-line vue/no-mutating-props
            this.notifyMessage = "A message has been sent to your email to reset your password"
          } else {
            // eslint-disable-next-line vue/no-mutating-props
            this.notifyMessage = "Could not initiate reset password"
            return this.serverError;
          }
        } catch(err) {
          this.serverError = "Something went wrong. Please try again";
          return err;
        }
      } else {
        this.inputError = "emailForgotPassword";
      }
    },
    getUserTypeHeader() {
      if(this.getUserType === UserTypeEnum.Professor) {
        return "Professor";
      } else if(this.getUserType === UserTypeEnum.Student) {
        return "Student";
      } else if(this.getUserType === UserTypeEnum.Admin) {
        return "Administrator";
      }
    },
    validateForm() {
      if(this.validateEmail(this.currentEmail)) {
        if(!this.password) {
          this.inputError = "password";
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    validateEmail(email) {
      let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(email && re.test(String(email).toLowerCase())) {
        return true;
      } else {
        this.inputError = "email";
        return false;
      }
    },
    async submitLogin() {
      this.httpWait = true;
      if(this.validateForm()) {
        const data = {
          authParameters: {
            USERNAME: this.currentEmail.toLowerCase(),
            PASSWORD: this.password
          },
          groupName: this.getUserType
        };
        try {
          const response = await fetch(`${this.url}/authentication`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Request-Method': 'POST'
            },
            body: JSON.stringify(data)
          });
          const responseJson = await response.json();          
          if(response.ok) {
            const token = responseJson.input["AuthenticationResult"]["IdToken"];
            const accessToken = responseJson.input["AuthenticationResult"]["AccessToken"];
            const tokenExpSeconds = responseJson.input["AuthenticationResult"]["ExpiresIn"];
            const refreshToken = responseJson.input["AuthenticationResult"]["RefreshToken"];
            const currentTimestamp = Date.now();
            const tokenExpTime = currentTimestamp + (tokenExpSeconds * 1000);
            await this.setUserToken(token);
            await this.setAccessToken(accessToken);
            await this.configureUserEmail(this.currentEmail.toLowerCase());
            await this.setUserTokenExpTime(tokenExpTime);
            await this.setUserRefreshToken(refreshToken);
            if(this.getUserType === UserTypeEnum.Admin) {
              try {
                await this.validateAdminLicense({
                  userEmail: this.currentEmail.toLowerCase()
                });

                this.httpWait = false;
                this.$router.push({
                  name: 'AdminHome'
                });
              } catch(err) {
                if(err.graphQLErrors && err.graphQLErrors.length) {
                  const errorMessage = err.graphQLErrors[0].message;
                  if(errorMessage) {
                    this.serverError = errorMessage;
                  }
                } else {
                  this.serverError = "Something went wrong. Please try again";
                }
                this.httpWait = false;
              }
            } else {
              try {
                await this.fetchSemesterList();
                this.httpWait = false;
              } catch(err) {
                if(err.graphQLErrors && err.graphQLErrors.length) {
                  const errorMessage = err.graphQLErrors[0].message;
                  if(errorMessage === "user license is revoked, no repurchase") {
                    this.serverError = "This license has been revoked and flagged. Please contact Accountonomics support for more details.";
                  } 
                  if(errorMessage === "user license is revoked") {
                    this.serverError = "Invalid license.";
                  }
                } 
                this.httpWait = false;
                return;
              }
              this.$router.push({
                name: 'Semester'
              });
            }
          } else {
            if(responseJson.code === "UserNotFoundException" || responseJson.message === "Incorrect username or password.") {
              this.serverError = "Incorrect username or password";
            } else if(responseJson.message === "not authorized") {
              this.serverError = "Not authorized";
            } else if(responseJson.message && responseJson.message.includes("Email not confirmed")) {
              this.serverError = "Email not confirmed. Please check your email for a confirmation link.";
            } else {
              this.serverError = "Something went wrong. Please try again";
            }
            this.httpWait = false;
            return this.serverError;
          }
        } catch(err) {
          this.serverError = "Something went wrong. Please try again";
          this.httpWait = false;
          return err;
        }
      }
      this.httpWait = false;
    },
    async loginWithGoogle() {
      this.httpWait = true;
      this.serverError = "";

      try {
        await this.startGoogleOAuthRedirect();
      } catch(err) {
        this.serverError = 'Google sign-in failed';
        if(err instanceof Error) {
          console.error('Google Redirect Error:', err.message, err.stack);
        } else {
          console.error('Google Redirect Error:', err);
        }
        this.httpWait = false;
      }
    },
    startGoogleOAuthRedirect() {
      return new Promise((resolve, reject) => {
        if(!window.google || !window.google.accounts || !window.google.accounts.oauth2) {
          reject(new Error('Google OAuth2 library is not loaded'));
          return;
        }

        if(!this.googleClientId) {
          reject(new Error('Google client id is not configured'));
          return;
        }

        const redirectUri = getGoogleRedirectUri(this.getUserType);
        const codeClient = window.google.accounts.oauth2.initCodeClient({
          client_id: this.googleClientId,
          scope: 'openid email profile',
          ux_mode: 'redirect',
          redirect_uri: redirectUri,
          state: this.getUserType
        });

        codeClient.requestCode();
        resolve(true);
      });
    },
    async loadGoogleScript() {
      if(window.google && window.google.accounts && window.google.accounts.id) {
        return;
      }

      await new Promise((resolve, reject) => {
        const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
        if(existingScript) {
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    goToOnboard() {
      this.$router.push({
        name: 'Onboard',
        params: {
          showBackButton: true,
          successCb: this.onboardSuccessCallback
        }
      });
    },
    onboardSuccessCallback() {
      this.$router.push({
        name: 'Semester'
      });
		},
    enableSubmitOnEnterKey() {
      document.onkeydown = (e) => {
        e = e || window.event;
        if(e.which === 13 || e.keyCode === 13) {
          this.submitLogin();
        }
      }
    }
  },
  props: {
    notifyMessage: String,
    email: String,
  },
  async created() {
    if(localStorage.getItem("isDarkMode") === "true") {
			document.body.classList.add('dark-mode');
		} else {
			document.body.classList.remove('dark-mode');
		}
    await this.configureUserType();
    if(this.$route.params.notifyMessage) {
      // eslint-disable-next-line vue/no-mutating-props
      this.notifyMessage = this.$route.params.notifyMessage;
    }
    if(this.email) {
      this.currentEmail = this.email.toLowerCase();
    }
    if(this.googleClientId) {
      try {
        await this.loadGoogleScript();
      } catch(err) {
        this.serverError = "Google sign-in is currently unavailable";
      }
    }
    window.addEventListener('keydown', this.enableSubmitOnEnterKey);
  },
  destroyed () {
    window.removeEventListener('keydown', this.enableSubmitOnEnterKey);
  },
}
</script>

<style scoped>

  h1, h2, h3, span, md-input {
    color: var(--text-primary);
  }

  .login-wrapper {
    padding: 0px;
  }
  .register-wrapper {
    padding: 1em;
    height: 125px;
  }
 .main-box {
    padding: 24px;
    margin: 1em;
    min-height: 280px;
    border: 2px solid var(--border-color);
    border-radius: 4px;
  }
  .text-center {
    text-align: center;
  }
  .btn-group {
    padding: 1em;
  }

  .register-group{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
  }
  .error {
    color: #ff1744;
  }
  .form-error {
    display: block!important;
    left: 0;
    height: 20px;
    position: absolute;
    bottom: -22px;
    font-size: 12px;
    transition: .3s cubic-bezier(.4,0,.2,1);
  }
  .notify-message {
    color: var(--onboard-message-color);
  }

  .underline:hover {
    text-decoration: underline;
  }
  .btn-wrapper {
		display: inline-block;
	}
	.btn-container {
		padding-top: 20px;
		padding-left: 20px;
		text-align: left;
	}

  @media screen and (max-width: 960px){
    .register-wrapper {
      padding: 0;
      height: 0;
    }
  }

  .gsi-material-button {
  user-select: none;
  appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  border-radius: 4px;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Roboto', arial, sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  transition: background-color .218s, border-color .218s, box-shadow .218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 10px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  flex-grow: 1;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  color: black;
}

.gsi-material-button .gsi-material-button-state {
  transition: opacity .218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state, 
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}

</style>